import { render } from "./FAQClientCategory.vue?vue&type=template&id=6b82b67e&scoped=true"
import script from "./FAQClientCategory.vue?vue&type=script&lang=js"
export * from "./FAQClientCategory.vue?vue&type=script&lang=js"

import "./FAQClientCategory.vue?vue&type=style&index=0&id=6b82b67e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b82b67e"

export default script